import { Children, cloneElement, memo, useCallback } from "react";
import PropTypes from "prop-types";
import { animated, useTransition } from "react-spring";
import classNames from "classnames";
import "./SidePanel.scss";
import * as ReactDOM from "react-dom";
import { isServerSide } from "app/utils/utils";
import useBlockScroll from "app/utils/hooks/useBlockScroll";

/**
 * ATTENTION:
 * Ne pas mettre de state dans cette classe sinon l'autoFocus des champs input
 * ne fonctionnera pas sur iOS (iPhone, iPad).
 */
const SidePanel = ({
	children,
	isOpen,
	onClose,
	direction,
	disableBlockViewPortScroll,
	className,
}) => {
	const isRTL = direction === "rtl";

	const transitions = useTransition(isOpen, null, {
		from: { transform: isRTL ? "translateX(100%)" : "translateX(-100%)" },
		enter: { transform: "translateX(0px)" },
		leave: { transform: isRTL ? "translateX(100%)" : "translateX(-100%)" },
		option: {
			delay: 75,
			duration: 200,
		},
	});

	useBlockScroll({ isModalOpen: isOpen && !disableBlockViewPortScroll });

	const hideSidePanel = useCallback(() => {
		onClose();
	}, []);

	const asideClass = classNames(
		{
			"side-panel": true,
			"side-panel--rtl": direction === "rtl",
			"side-panel--pushed": isOpen,
		},
		className
	);

	const childrenWithProps = Children.map(children, child => {
		return cloneElement(child, {
			hideSidePanel,
			isOpen,
		});
	});

	return (
		!isServerSide &&
		ReactDOM.createPortal(
			transitions.map(({ item, key, props }) =>
				item ? (
					<animated.div style={props} key={key} className={asideClass}>
						{childrenWithProps}
					</animated.div>
				) : null
			),
			document.getElementById("perfectstay")
		)
	);
};

SidePanel.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func,
	direction: PropTypes.oneOf(["rtl", "ltr"]),
	className: PropTypes.string,
};

export default memo(SidePanel);
